export const NEW = 'NEW';
export const ACTIVE = 'ACTIVE';
